import { useFormContext } from 'react-hook-form';
import { Content } from 'src/contexts/ContentContext';
import { PosFormField } from 'src/core/POS/PosFormField';
import { vars } from 'src/core/themes';
import { FieldWrapper } from 'src/modals/common';
import { PurchaseCurrency } from 'src/modals/common/Purchase/PurchaseCurrency';
import { PurchaseSellerAccountSelector } from 'src/modals/common/Purchase/PurchaseSellerAccountSelector/PurchaseSellerAccountSelector';
import { ContentId } from 'src/utils/constants/contentId';
import { PurchaseOrderDetailsInput } from 'src/utils/purchaseUtils';

import * as styles from '../common/Purchase/PurchaseVendorHeader/PurchaseVendorHeader.css';
import { summaryWrapper } from '../common/Summary/Summary.css';
import {
  headerLeftGroup,
  headerRightGroup,
} from './MultiplePurchaseWizard.css';

export const MultiplePurchaseVendorHeader = () => {
  const { formState } = useFormContext<PurchaseOrderDetailsInput>();

  return (
    <>
      <div className={summaryWrapper} style={{ marginBottom: vars.spacing.xl }}>
        <header className={styles.headerSection}>
          <div className={styles.headerGroups}>
            <div className={headerLeftGroup}>
              <div className={styles.vendorContainer}>
                <PosFormField
                  errors={formState.errors.buyerUserId?.message}
                  label={<Content id={ContentId.PurchasedBy} />}
                >
                  <PurchaseSellerAccountSelector />
                </PosFormField>
              </div>
            </div>
            <div className={headerRightGroup}>
              <FieldWrapper>
                <PurchaseCurrency />
              </FieldWrapper>
            </div>
          </div>
        </header>
      </div>
    </>
  );
};
